export default __webpack_public_path__ + "static/media/home-web-agency-img-04.b6aeb9a5.jpg";